import React from 'react';

import BottomSheet from 'components/BottomSheet';

import { Container, Title, Text, Close } from './styles';

interface Props {
  show: boolean;
  title: string;
  content?: string;
  close: string;
  children?: JSX.Element;
  onClose: () => void;
  onConfirm?: () => void;
}

export const StyledAlertBottomSheet = ({ show, title, content, close, onClose, children, onConfirm }: Props) => (
  <BottomSheet modal noHeader show={show} onClose={onClose}>
    <Container>
      <Title>{title}</Title>
      {children || <Text>{content}</Text>}
      <Close
        value={close}
        onClick={
          onConfirm
            ? () => {
                onConfirm();
                onClose();
              }
            : onClose
        }
      />
    </Container>
  </BottomSheet>
);

export default StyledAlertBottomSheet;
